<template>
    <MainContent title="Crear Compañia">
        <template v-slot:header>
            <h3 class="card-title">Crear Compañia</h3>
        </template>
        <template v-slot:content v-if="!loading">
            <FormComponent
                :compania="compania"
                :error="error"
                @terminado="crearCompania()"
                @imagenBorrada="{ error = null }"
            />
        </template>
    </MainContent>
</template>

<script>
    import MainContent from "@/components/backend/components/MainContent";
    import FormComponent from '@/components/backend/compania-eventos/FormComponent';

    export default {
        data() {
            return {
                loading: false,
                compania: {
                    filters: {},
                    nif: '',
                    nombre: '',
                    direccion: '',
                    ciudad: '',
                    cp: null,
                    cuenta: '',
                    email: '',
                    telefono: null,
                    tipo_tpv: ''
                },
                error: null
            }
        },
        methods: {
            crearCompania() {
                this.loading = true;

                this.compania.filters = {
                    teatro_id: this.teatro.id            
                }

                this.$store.dispatch(this.config.getVuexAlias('back.teatro.compania-eventos.crear'), this.compania).then(res => {
                    this.$toast.success(res.data.message);
                    if (this.$route.params.evento_id) {
                        this.$router.push({ name: 'back.events.compania', params: { evento_id: this.$route.params.evento_id }});
                    } else {
                        this.$router.push({ name: 'back.compania-eventos.index' });
                    }
                }).catch(error => {
                    this.$toast.error('Ha ocurrido un error');
                    this.error = error.response?.data?.errors?.imagen[0];
                }).finally(() => {
                    this.loading = false;
                });
            }
        },
        computed: {
            teatro() {
                return this.$store.getters.getTeatro;
            }
        },
        components: {
            MainContent, FormComponent
        }
    }
</script>
